import { Typography, Grid, Box, List, ListItem, Link } from '@mui/material';
import { colors } from 'src/components/App/colors';

const ALSFormContent = () => {
  return (
    <Grid container>
      <Typography sx={{ color: colors['charcoal.700'], mb: 2, width: '100%' }} variant={'body2'}>
        Use this form to record advanced life support (ALS) or advanced paediatric life support
        (APLS) with cardiopulmonary resuscitation (CPR) courses.
      </Typography>
      <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
        <Box component="span" fontWeight={600}>
          Important: &nbsp;
        </Box>
      </Typography>
      <List
        sx={{
          color: colors['charcoal.700'],
          listStyleType: 'disc',
          width: '100%',
          listStylePosition: 'outside',
          pl: 3
        }}
      >
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            Courses completed through an Australian Resuscitation Council (ARC) Course Centre or
            RACGP CPD Approved Provider will be automatically recorded within 14 days.
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            If your ARC ALS course does not appear in your History within 14 days, you can{' '}
            <Link
              rel="noreferrer"
              target="_blank"
              href="https://www.emailmeform.com/builder/form/GYM4oR9XZFwdf6WP6O"
            >
              submit a request to the ARC to upload your CPD record
            </Link>
            .
          </Typography>
        </ListItem>
      </List>
      <Typography sx={{ color: colors['charcoal.700'], mt: 1 }} variant={'body2'}>
        Use this form when you have completed an advanced life support (ALS) or advanced paediatric
        life support (APLS) course through a non-RACCP CPD provider covering the following:
      </Typography>
      <List
        sx={{
          color: colors['charcoal.700'],
          listStyleType: 'disc',
          width: '100%',
          listStylePosition: 'outside',
          pl: 3
        }}
      >
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            use of ARC protocols
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            management of airway and breathing
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            defibrillation
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            assessment of competency using observation of clinical performance in simulated
            scenarios.
          </Typography>
        </ListItem>
      </List>
      <Typography sx={{ color: colors['charcoal.700'], width: '100%' }} variant={'body2'}>
        <Box component="span" fontWeight={600}>
          Evidence:
        </Box>
      </Typography>
      <Typography sx={{ mb: 0, color: colors['charcoal.700'] }} variant={'body2'}>
        Please submit:
      </Typography>
      <List
        sx={{
          color: colors['charcoal.700'],
          listStyleType: 'disc',
          width: '100%',
          listStylePosition: 'outside',
          pl: 3,
          mb: 1
        }}
      >
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            certificate/statement of completion
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            course outline or program.
          </Typography>
        </ListItem>
      </List>
    </Grid>
  );
};
export { ALSFormContent };
